const { ACTUAL_LEVEL_IDS } = require('common/constants');

export function generateActualLevelMap(maxLevel) {
  const level = ACTUAL_LEVEL_IDS.find((e) => e.id === maxLevel);

  return ACTUAL_LEVEL_IDS.slice(0, ACTUAL_LEVEL_IDS.indexOf(level) + 1).map(
    (e) => e.label.toString(),
  );
}
